
        import { Pane } from 'https://cdn.jsdelivr.net/npm/tweakpane@4.0.3/dist/tweakpane.min.js';
        import { MatrixAnimation } from './src/main.ts';
        import { MATRIX_PRESETS } from './src/samples.ts';
    
        let currentConfig = structuredClone(MATRIX_PRESETS['matrix']);
        const animation = new MatrixAnimation(".container", currentConfig);

        const presetMap = {
            "cyberpunk": MATRIX_PRESETS["cyberpunk"],
            "ocean-blue": MATRIX_PRESETS["ocean-blue"],
            "fire-red": MATRIX_PRESETS["fire-red"],
            "monochrome": MATRIX_PRESETS["monochrome"],
            "purple-haze": MATRIX_PRESETS["purple-haze"],
            "neon-pink": MATRIX_PRESETS["neon-pink"],
            "matrix": MATRIX_PRESETS["matrix"],
            "digital-rain": MATRIX_PRESETS["digital-rain"],
        }
        let currentPreset = 'matrix';

        let pane;
        const initPane = () => {

            const element = document.querySelector(".tweakpane");
            const btn = document.querySelector(".show-button");

            element.style.transform = '';
            element.style.right = "10px";
            btn.style.opacity = 1;
            btn.style.right = "-100vw";

            pane?.dispose();
            pane = new Pane({
                container: element
            });

            const base = pane.addFolder({
                title: 'options',
                expanded: true,
            });

            // Ensure defaults for tweakpane bindings
            animation.options.autoStart = animation.options.autoStart ?? true;
            animation.options.rainHeight = animation.options.rainHeight ?? 0;
            animation.options.syncFrame = animation.options.syncFrame ?? true;
            animation.options.trailColorLogic = animation.options.trailColorLogic ?? 'random';
            animation.options.windSpeed = animation.options.windSpeed ?? 0;
            animation.options.windDirection = animation.options.windDirection ?? 'TD';
            animation.options.warmupIterations = animation.options.warmupIterations ?? 0;
            animation.options.headBloomSize = animation.options.headBloomSize ?? 0;
            animation.options.headBloomColor = animation.options.headBloomColor ?? '#ffffff';
            animation.options.trailBloomSize = animation.options.trailBloomSize ?? 0;
            animation.options.trailBloomColor = animation.options.trailBloomColor ?? '#ffffff';
            animation.options.rainGenerator = animation.options.rainGenerator ?? {};
            animation.options.rainGenerator.count = animation.options.rainGenerator.count ?? 0;
            animation.options.rainGenerator.density = animation.options.rainGenerator.density ?? 2;
            animation.options.rainGenerator.direction = animation.options.rainGenerator.direction ?? 'TD';
            animation.options.rainGenerator.randomizeXonLeaveView = animation.options.rainGenerator.randomizeXonLeaveView ?? false;
            animation.options.rainGenerator.randomizeYonLeaveView = animation.options.rainGenerator.randomizeYonLeaveView ?? false;
            if (!Array.isArray(animation.options.rainDrop) && typeof animation.options.rainDrop === 'object') {
                animation.options.rainDrop.direction = animation.options.rainDrop.direction ?? 'TD';
                animation.options.rainDrop.headColor = animation.options.rainDrop.headColor ?? 'rgba(255,255,255,0.8)';
                animation.options.rainDrop.trailColor = animation.options.rainDrop.trailColor ?? 'rgba(140,62,225,1)';
                animation.options.rainDrop.fontSize = animation.options.rainDrop.fontSize ?? 14;
                animation.options.rainDrop.randomizeScale = animation.options.rainDrop.randomizeScale ?? false;
                animation.options.rainDrop.minFontSize = animation.options.rainDrop.minFontSize ?? 12;
                animation.options.rainDrop.maxFontSize = animation.options.rainDrop.maxFontSize ?? 22;
                animation.options.rainDrop.moveSpeed = animation.options.rainDrop.moveSpeed ?? 0;
                animation.options.rainDrop.minMoveSpeed = animation.options.rainDrop.minMoveSpeed ?? 4;
                animation.options.rainDrop.maxMoveSpeed = animation.options.rainDrop.maxMoveSpeed ?? 12;
                animation.options.rainDrop.correlateScaleSpeed = animation.options.rainDrop.correlateScaleSpeed ?? false;
                animation.options.rainDrop.jitterLeftStrength = animation.options.rainDrop.jitterLeftStrength ?? 0;
                animation.options.rainDrop.jitterRightStrength = animation.options.rainDrop.jitterRightStrength ?? 0;
                animation.options.rainDrop.jitterUpStrength = animation.options.rainDrop.jitterUpStrength ?? 0;
                animation.options.rainDrop.jitterDownStrength = animation.options.rainDrop.jitterDownStrength ?? 0;
                animation.options.rainDrop.alignToColumns = animation.options.rainDrop.alignToColumns ?? true;
                animation.options.rainDrop.frameDelay = animation.options.rainDrop.frameDelay ?? 50;
                animation.options.rainDrop.minFrameDelay = animation.options.rainDrop.minFrameDelay ?? 30;
                animation.options.rainDrop.maxFrameDelay = animation.options.rainDrop.maxFrameDelay ?? 60;
                animation.options.rainDrop.randomizeFrameDelay = animation.options.rainDrop.randomizeFrameDelay ?? false;
                animation.options.rainDrop.randomizePosition = animation.options.rainDrop.randomizePosition ?? false;
                animation.options.rainDrop.fontFamily = animation.options.rainDrop.fontFamily ?? 'monospace';
                animation.options.rainDrop.trailColors = animation.options.rainDrop.trailColors ?? [];
                if (animation.options.rainDrop.trailColors.length > 0 && !animation.options.rainDrop.trailColor) {
                    animation.options.rainDrop.trailColor = animation.options.rainDrop.trailColors[0];
                }
            }

            base.addBinding({ preset: currentPreset }, 'preset', {
                options: {
                    "Cyberpunk": 'cyberpunk',
                    "Ocean Blue": 'ocean-blue',
                    "Fire Red": 'fire-red',
                    "Monochrome": 'monochrome',
                    "Purple Haze": 'purple-haze',
                    "Neon Pink": 'neon-pink',
                    "Matrix": 'matrix',
                    "Digital Rain": 'digital-rain',
                },
            }).on('change', ({ value }) => {
                const options = presetMap[currentPreset = value];
                currentConfig = structuredClone(options);
                
                // Update the animation
                animation.pause();
                animation.options = structuredClone(options);
                animation.applyOptions();
                animation.resetRaindrops();
                animation.play();

                setTimeout(() => {
                    initPane();
                })
            });

            base.addBinding({ chars: 'Matrix' }, 'chars', {
                options: {
                    "Matrix": "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZアァカサタナハマヤャラワガザダバパイィキシチニヒミリヰギジヂビピウゥクスツヌフムユュルグズブヅプエェケセテネヘメレヱゲゼデベペオォコソトノホモヨョロヲゴゾドボポヴッン",
                    "Braille": "⠁⠂⠃⠄⠅⠆⠇⠈⠉⠊⠋⠌⠍⠎⠏⠐⠑⠒⠓⠔⠕⠖⠗⠘⠙⠚⠛⠜⠝⠞⠟⠠⠡⠢⠣⠤⠥⠦⠧⠨⠩⠪⠫⠬⠭⠮⠯⠰⠱⠲⠳⠴⠵⠶⠷⠸⠹⠺⠻⠼⠽⠾⠿⡀⡁⡂⡃⡄⡅⡆⡇⡈⡉⡊⡋⡌⡍⡎⡏⡐⡑⡒⡓⡔⡕⡖⡗⡘⡙⡚⡛⡜⡝⡞⡟⡠⡡⡢⡣⡤⡥⡦⡧⡨⡩⡪⡫⡬⡭⡮⡯⡰⡱⡲⡳⡴⡵⡶⡷⡸⡹⡺⡻⡼⡽⡾⡿⢀⢁⢂⢃⢄⢅⢆⢇⢈⢉⢊⢋⢌⢍⢎⢏⢐⢑⢒⢓⢔⢕⢖⢗⢘⢙⢚⢛⢜⢝⢞⢟⢠⢡⢢⢣⢤⢥⢦⢧⢨⢩⢪⢫⢬⢭⢮⢯⢰⢱⢲⢳⢴⢵⢶⢷⢸⢹⢺⢻⢼⢽⢾⢿⣀⣁⣂⣃⣄⣅⣆⣇⣈⣉⣊⣋⣌⣍⣎⣏⣐⣑⣒⣓⣔⣕⣖⣗⣘⣙⣚⣛⣜⣝⣞⣟⣠⣡⣢⣣⣤⣥⣦⣧⣨⣩⣪⣫⣬⣭⣮⣯⣰⣱⣲⣳⣴⣵⣶⣷⣸⣹⣺⣻⣼⣽⣾⣿",
                    "Numbers": "0123456789",
                    "Symbols": "+=#%*/\\[]{}()&^$@!~`'\"|<>,.?",
                    "Mathematical Operators": "⊕⊖⊗⊘⊙⊚⊛⊜⊝⊞⊟⊠⊡",
                    "Shade Blocks": "░▒▓█",
                    "Blocks Elements": "▀▁▂▃▄▅▆▇█▉▊▋▌▍▎▏▐",
                    "Block Quadrants": "▖▗▘▙▚▛▜▝▞▟",
                    "Bengali": "ঀঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহঽৎড়ঢ়য়ৠৡ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻ৼ৽",
                    "Rejang": "ꤰꤱꤲꤳꤴꤵꤶꤷꤸꤹꤺꤻꤼꤽꤾꤿꥀꥁꥂꥃꥄꥅꥆ",
                    "Runic": "ᚠᚡᚢᚣᚤᚥᚦᚧᚨᚩᚪᚫᚬᚭᚮᚯᚰᚱᚲᚳᚴᚵᚶᚷᚸᚹᚺᚻᚼᚽᚾᚿᛀᛁᛂᛃᛄᛅᛆᛇᛈᛉᛊᛋᛌᛍᛎᛏᛐᛑᛒᛓᛔᛕᛖᛗᛘᛙᛚᛛᛜᛝᛞᛟᛠᛡᛢᛣᛤᛥᛦᛧᛨᛩᛪ᛫᛬᛭ᛮᛯᛰᛱᛲᛳᛴᛵᛶᛷᛸ",
                    "Tetragrams": "𝌀𝌁𝌂𝌃𝌄𝌅𝌆𝌇𝌈𝌉𝌊𝌋𝌌𝌍𝌎𝌏𝌐𝌑𝌒𝌓𝌔𝌕𝌖𝌗𝌘𝌙𝌚𝌛𝌜𝌝𝌞𝌟𝌠𝌡𝌢𝌣𝌤𝌥𝌦𝌧𝌨𝌩𝌪𝌫𝌬𝌭𝌮𝌯𝌰𝌱𝌲𝌳𝌴𝌵𝌶𝌷𝌸𝌹𝌺𝌻𝌼𝌽𝌾𝌿𝍀𝍁𝍂𝍃𝍄𝍅𝍆𝍇𝍈𝍉𝍊𝍋𝍌𝍍𝍎𝍏𝍐𝍑𝍒𝍓𝍔𝍕𝍖",
                    "Zanzabar": "𑨀𑨋𑨌𑨍𑨎𑨏𑨐𑨑𑨒𑨓𑨔𑨕𑨖𑨗𑨘𑨙𑨚𑨛𑨜𑨝𑨞𑨟𑨠𑨡𑨢𑨣𑨤𑨥𑨦𑨧𑨨𑨩𑨪𑨫𑨬𑨭𑨮𑨯𑨰𑨱𑨲𑨿𑩀𑩂𑩃𑩄𑩅𑩆",
                    "Old Turkic": "𐰀𐰁𐰂𐰃𐰄𐰅𐰆𐰇𐰈𐰉𐰊𐰋𐰌𐰍𐰎𐰏𐰐𐰑𐰒𐰓𐰔𐰕𐰖𐰗𐰘𐰙𐰚𐰛𐰜𐰝𐰞𐰟𐰠𐰡𐰢𐰣𐰤𐰥𐰦𐰧𐰨𐰩𐰪𐰫𐰬𐰭𐰮𐰯𐰰𐰱𐰲𐰳𐰴𐰵𐰶𐰷𐰸𐰹𐰺𐰻𐰼𐰽𐰾𐰿𐱀𐱁𐱂𐱃𐱄𐱅𐱆𐱇𐱈",
                    "Aegan": "𐄇𐄈𐄉𐄊𐄋𐄌𐄍𐄎𐄏𐄐𐄑𐄒𐄓𐄔𐄕𐄖𐄗𐄘𐄙𐄚𐄛𐄜𐄝𐄞𐄟𐄠𐄡𐄢𐄣𐄤𐄥𐄦𐄧𐄨𐄩𐄪𐄫𐄬𐄭𐄮𐄯𐄰𐄱𐄲𐄳",
                    "Geometric Shapes Extended": "🞀🞁🞂🞃🞄🞅🞆🞇🞈🞉🞊🞋🞌🞍🞎🞏🞐🞑🞒🞓🞔🞕🞖🞗🞘🞙🞚🞛🞜🞝🞞🞟🞠🞡🞢🞣🞤🞥🞦🞧🞨🞩🞪🞫🞬🞭🞮🞯🞰🞱🞲🞳🞴🞵🞶🞷🞸🞹🞺🞻🞼🞽🞾🞿🟀🟁🟂🟃🟄🟅🟆🟇🟈🟉🟊🟋🟌🟍🟎🟏🟐🟑🟒🟓🟔🟕🟖🟗🟘",
                    "Nushu": "𛅰𛅱𛅲𛅳𛅴𛅵𛅶𛅷𛅸𛅹𛅺𛅻𛅼𛅽𛅾𛅿𛆀𛆁𛆂𛆃𛆄𛆅𛆆𛆇𛆈𛆉𛆊𛆋𛆌𛆍𛆎𛆏𛆐𛆑𛆒𛆓𛆔𛆕𛆖𛆗𛆘𛆙𛆚𛆛𛆜𛆝𛆞𛆟𛆠𛆡𛆢𛆣𛆤𛆥𛆦𛆧𛆨𛆩𛆪𛆫𛆬𛆭𛆮𛆯𛆰𛆱𛆲𛆳𛆴𛆵𛆶𛆷𛆸𛆹𛆺𛆻𛆼𛆽𛆾𛆿𛇀𛇁𛇂𛇃𛇄𛇅𛇆𛇇𛇈𛇉𛇊𛇋𛇌𛇍𛇎𛇏𛇐𛇑𛇒𛇓𛇔𛇕𛇖𛇗𛇘𛇙𛇚𛇛𛇜𛇝𛇞𛇟𛇠𛇡𛇢𛇣𛇤𛇥𛇦𛇧𛇨𛇩𛇪𛇫𛇬𛇭𛇮𛇯𛇰𛇱𛇲𛇳𛇴𛇵𛇶𛇷𛇸𛇹𛇺𛇻𛇼𛇽𛇾𛇿𛈀𛈁𛈂𛈃𛈄𛈅𛈆𛈇𛈈𛈉𛈊𛈋𛈌𛈍𛈎𛈏𛈐𛈑𛈒𛈓𛈔𛈕𛈖𛈗𛈘𛈙𛈚𛈛𛈜𛈝𛈞𛈟𛈠𛈡𛈢𛈣𛈤𛈥𛈦𛈧𛈨𛈩𛈪𛈫𛈬𛈭𛈮𛈯𛈰𛈱𛈲𛈳𛈴𛈵𛈶𛈷𛈸𛈹𛈺𛈻𛈼𛈽𛈾𛈿𛉀𛉁𛉂𛉃𛉄𛉅𛉆𛉇𛉈𛉉𛉊𛉋𛉌𛉍𛉎𛉏𛉐𛉑𛉒𛉓𛉔𛉕𛉖𛉗𛉘𛉙𛉚𛉛𛉜𛉝𛉞𛉟𛉠𛉡𛉢𛉣𛉤𛉥𛉦𛉧𛉨𛉩𛉪𛉫𛉬𛉭𛉮𛉯𛉰𛉱𛉲𛉳𛉴𛉵𛉶𛉷𛉸𛉹𛉺𛉻𛉼𛉽𛉾𛉿𛊀𛊁𛊂𛊃𛊄𛊅𛊆𛊇𛊈𛊉𛊊𛊋𛊌𛊍𛊎𛊏𛊐𛊑𛊒𛊓𛊔𛊕𛊖𛊗𛊘𛊙𛊚𛊛𛊜𛊝𛊞𛊟𛊠𛊡𛊢𛊣𛊤𛊥𛊦𛊧𛊨𛊩𛊪𛊫𛊬𛊭𛊮𛊯𛊰𛊱𛊲𛊳𛊴𛊵𛊶𛊷𛊸𛊹𛊺𛊻𛊼𛊽𛊾𛊿𛋀𛋁𛋂𛋃𛋄𛋅𛋆𛋇𛋈𛋉𛋊𛋋𛋌𛋍𛋎𛋏𛋐𛋑𛋒𛋓𛋔𛋕𛋖𛋗𛋘𛋙𛋚𛋛𛋜𛋝𛋞𛋟𛋠𛋡𛋢𛋣𛋤𛋥𛋦𛋧𛋨𛋩𛋪𛋫𛋬𛋭𛋮𛋯𛋰𛋱𛋲𛋳𛋴𛋵𛋶𛋷𛋸𛋹𛋺𛋻",
                },
            }).on('change', ({ value }) => {
                const newArr = animation.options.charArrays = [value];
                animation.applyOptions();
                animation.raindrops.forEach(drop => drop.randomizeChars())
            });

            base.addBinding(animation.options, 'headBloomSize', { min: 0, max: 30, step: 1 });
            base.addBinding(animation.options, 'headBloomColor', { input: 'color:rgba' });
            base.addBinding(animation.options, 'trailBloomSize', { min: 0, max: 30, step: 1 });
            base.addBinding(animation.options, 'trailBloomColor', { input: 'color:rgba' });
            base.addBinding(animation.options, 'rainWidth', { min: 0, max: 100, step: 1 });
            base.addBinding(animation.options, 'rainHeight', { min: 0, max: 100, step: 1 });
            base.addBinding(animation.options, 'minFrameTime', { min: 5, max: 1000, step: 1 });
            base.addBinding(animation.options, 'fadeStrength', { min: 0, max: 1 });
            base.addBinding(animation.options, 'syncFrame');
            base.addBinding(animation.options, 'trailColorLogic', { options: { "Random": 'random', "Sequential": 'sequential' } });
            base.addBinding(animation.options, 'windSpeed', { min: 0, max: 20, step: 1 });
            base.addBinding(animation.options, 'windDirection', { options: [{text: "Top=>Down", value: 'TD'}, { text: "Bottom=>Up", value: 'BU' }, { text: "Left=>Right", value: "LR"}, { text: "Right=>Left", value: "RL" }] }).on("change", ()=>{
                animation.initCanvasShift();
            });
            base.addBinding(animation.options, 'warmupIterations', { min: 0, max: 500, step: 1 });
            base.addBinding(animation.options, 'autoStart');


            const rainGen = pane.addFolder({
                title: 'Rain Generator',
                expanded: false,
            });
            rainGen.addBinding(animation.options.rainGenerator, 'density', { min: 0, max: 5, step: 0.1 });
            rainGen.addBinding(animation.options.rainGenerator, 'count', { min: 0, max: 1000, step: 1 });
            rainGen.addBinding(animation.options.rainGenerator, 'direction', { options: [{ text: "Top=>Down", value: 'TD' }, { text: "Bottom=>Up", value: 'BU' }, { text: "Left=>Right", value: "LR" }, { text: "Right=>Left", value: "RL" }] });
            rainGen.addBinding(animation.options.rainGenerator, 'randomizeXonLeaveView');
            rainGen.addBinding(animation.options.rainGenerator, 'randomizeYonLeaveView');
            rainGen.on('change', (evt) => {
                if (['density', 'count', 'direction'].includes(evt.target.key)) {
                    animation.resetRaindrops();
                }
            });

            const raindrop = pane.addFolder({
                title: 'Raindrop Options',
                expanded: true
            });

            raindrop.addBinding(animation.options.rainDrop, 'direction', { options: [{ text: "Top=>Down", value: 'TD' }, { text: "Bottom=>Up", value: 'BU' }, { text: "Left=>Right", value: "LR" }, { text: "Right=>Left", value: "RL" }] }).on('change', (ev) => {
                animation.options.rainDrop.direction = ev.value;
                animation.raindrops.forEach(rd => rd.initMoveDirection());
            });
            raindrop.addBinding(animation.options.rainDrop, 'headColor', { input: 'color:rgba' });
            raindrop.addBinding(animation.options.rainDrop, 'trailColor', { input: 'color:rgba' });
            const trailColorsProxy = {
                get colors() {
                    return (animation.options.rainDrop.trailColors ?? []).join(', ');
                },
                set colors(v) {
                    animation.options.rainDrop.trailColors = v.split(',').map(s => s.trim()).filter(Boolean);
                }
            };
            raindrop.addBinding(trailColorsProxy, 'colors', { label: 'trailColors' }).on('change', () => {
                animation.raindrops.forEach(drop => {
                    drop.config.trailColors = animation.options.rainDrop.trailColors;
                });
            });
            raindrop.addBinding(animation.options.rainDrop, 'fontSize', { min: 1, max: 100, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'randomizeScale');
            raindrop.addBinding(animation.options.rainDrop, 'minFontSize', { min: 1, max: 100, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'maxFontSize', { min: 1, max: 100, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'moveSpeed', { min: 0, max: 100, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'minMoveSpeed', { min: 0, max: 100, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'maxMoveSpeed', { min: 0, max: 100, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'correlateScaleSpeed', { options: { "Off": false, "Proportional": true, "Inverse": "inverse" } });
            raindrop.addBinding(animation.options.rainDrop, 'jitterLeftStrength', { min: 0, max: 10, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'jitterRightStrength', { min: 0, max: 10, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'jitterUpStrength', { min: 0, max: 10, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'jitterDownStrength', { min: 0, max: 10, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'fontFamily');
            raindrop.addBinding(animation.options.rainDrop, 'alignToColumns');
            raindrop.addBinding(animation.options.rainDrop, 'frameDelay', { min: 1, max: 500, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'minFrameDelay', { min: 1, max: 500, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'maxFrameDelay', { min: 1, max: 500, step: 1 });
            raindrop.addBinding(animation.options.rainDrop, 'randomizeFrameDelay');
            raindrop.addBinding(animation.options.rainDrop, 'randomizePosition');

            raindrop.on('change', (evt) => {
                const hardReload = 
                    [
                        'direction',
                    ].includes(evt.target.key);
                
                if (hardReload) {
                    // We need to reset the whole array of raindrops
                    animation.resetRaindrops();
                }
                else {
                    // Something we can directly trigger an update in the config
                    animation.raindrops.forEach(drop => {
                        drop.config[evt.target.key] = evt.value
                    })
                }
            })

            pane.addBlade({
                view: 'separator',
            });

            pane.addButton({
                title: 'Reset',
                // label: 'counter',   // optional
            }).on('click', () => {
                animation.applyOptions(currentConfig);
                initPane();
            });
            pane.addButton({
                title: 'Hide',
            }).on('click', () => {
                element.style.transform = "translateX(calc(100% + 10px))";
                btn.style.opacity = 1;
                // element.style.left = "100%";

                btn.style.right = "0";

                btn.onclick = () => {
                    initPane();
                }

                setTimeout(() => {
                    btn.style.opacity = 0;
                }, 3000);
            });
        }

        initPane();
    